import { TellescopeModelFromName, useTellescopeInfiniteQuery } from "@tellescope/tanstack-query";
import { Button, cn, PaginatedList } from "@tellescope/ui";
import { Plus } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { EditTeamChannelDialog } from "../../team-chat";
import { ChatRoom } from "@tellescope/types-models";
import { NAV_ITEM_BUTTON_STYLES } from "../NavbarNavItem/constants";
import { SimpleNavItem } from "../NavbarNavItem";

export const NavbarTeamChatNavItem = () => {
  const { t } = useTranslation("sidebar");
  const navigate = useNavigate();
  const params = useParams();
  const internalTeamChatroomsQuery = useTellescopeInfiniteQuery({
    model: "chat_rooms",
    method: "load_team_chat",
    request: {
      limit: 25,
    },
    getNextPageParam: (lastPage) => lastPage.chat_rooms.at(-1)?.updatedAt,
    initialPageParam: undefined,
    paginateRequest: (lastUpdatedAt, request) => ({
      ...request,
      lastUpdatedAt,
    }),
    select: (data) =>
      data.pages.reduce<{
        chatrooms: ChatRoom[];
        endusers: TellescopeModelFromName<"endusers">[];
      }>(
        (acc, page) => {
          acc.chatrooms.push(...page.chat_rooms);
          acc.endusers.push(...page.endusers);

          return acc;
        },
        { chatrooms: [], endusers: [] }
      ),
  });

  return (
    <>
      <div className="border-t border-t-gray-200 w-full my-1" />
      <PaginatedList className="flex-grow overflow-x-hidden" hideScrollbarUntilScroll>
        <EditTeamChannelDialog
          onSave={({ id }) => {
            navigate(`/messaging/team-chat/${id}`);
          }}
        >
          <Button
            variant="ghost"
            className={cn(
              NAV_ITEM_BUTTON_STYLES,
              "justify-between flex-shrink",
              !internalTeamChatroomsQuery.data?.chatrooms.length && "mb-1"
            )}
          >
            <div className={cn("flex gap-4 flex-1 items-center")}>
              <Plus />
              {t("Add a team channel")}
            </div>
          </Button>
        </EditTeamChannelDialog>
        {internalTeamChatroomsQuery.isLoading || !internalTeamChatroomsQuery.data ? (
          <p className="text-xs text-muted-foreground px-4 py-3">{t("Loading team channels...")}</p>
        ) : (
          internalTeamChatroomsQuery.data?.chatrooms.map((chatroom) => (
            <SimpleNavItem
              key={chatroom.id}
              path={`/messaging/team-chat/${chatroom.id}`}
              isProtected
              label={() => chatroom.title || ""}
              icon={<span className="text-xs">{chatroom.emoji || "❓"}</span>}
              isActive={params.chatroomId === chatroom.id}
            />
          ))
        )}
      </PaginatedList>
    </>
  );
};
